import { render, staticRenderFns } from "./table-autocomplete-tag.vue?vue&type=template&id=4dbda16b"
import script from "./table-autocomplete-tag.vue?vue&type=script&lang=js"
export * from "./table-autocomplete-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports